"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTopItems = void 0;
var react_intl_1 = require("react-intl");
var messages_1 = require("../../messages");
var types_1 = require("./types");
var messages = messages_1.commonMessages.menu;
var newFeatureMessages = messages_1.commonMessages.general;
var useTopItems = function (_a) {
    var _b, _c;
    var isMachineManagementEnabled = _a.isMachineManagementEnabled, isEcomEnabled = _a.isEcomEnabled, ecomUrl = _a.ecomUrl, isCpqEnabled = _a.isCpqEnabled, isManualsEnabled = _a.isManualsEnabled, isWarrantyEnabled = _a.isWarrantyEnabled, isPSPEnabled = _a.isPSPEnabled, isDTCEnabled = _a.isDTCEnabled, isVideosEnabled = _a.isVideosEnabled, isServiceAndInformationBasePathEnabled = _a.isServiceAndInformationBasePathEnabled, newFeatureItems = _a.newFeatureItems, accountItems = _a.accountItems, activeAccountId = _a.activeAccountId, onAccountSelect = _a.onAccountSelect;
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    var activeAccountName = (_c = (_b = accountItems.find(function (account) { return account.id === activeAccountId; })) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : '';
    var CEPFleetOverview = {
        label: formatMessage(messages.fleetOverview),
        icon: 'agriculture',
        id: 'fleet-overview',
        to: "".concat(types_1.EAuthRoutes.FLEET_OVERVIEW),
    };
    var FSEFleetOverview = {
        label: formatMessage(messages.fleetOverview),
        key: 'fleet-overview',
        to: types_1.FSEAuthRoutes.FLEET_OVERVIEW,
        testId: 'sidebar-fse-fleet-overview',
    };
    var ECOMSidebarItem = {
        label: formatMessage(messages.partShop),
        icon: 'shopping_cart_checkout',
        to: ecomUrl,
        testId: 'sidebar-part-shop',
        isTargetBlank: true,
    };
    var CPQSidebarItem = {
        label: formatMessage(messages.newMachine),
        icon: 'add_home',
        to: 'https://cpq.agcocorp.com/',
        testId: 'sidebar-new-machine',
        isTargetBlank: true,
    };
    var warranty = {
        label: formatMessage(messages.warranty),
        key: 'fleet-warranty',
        to: isMachineManagementEnabled ? "".concat(types_1.EAuthRoutes.FLEET_OVERVIEW, "/warranty") : types_1.FSEAuthRoutes.FLEET_WARRANTY,
        testId: 'sidebar-warranty',
    };
    var manuals = {
        label: formatMessage(messages.manuals),
        key: 'manuals',
        to: isMachineManagementEnabled ? "".concat(types_1.FSEAuthRoutes.SERVICE_AND_INFORMATION, "/find-manuals") : types_1.FSEAuthRoutes.MANUALS,
        testId: 'sidebar-manuals',
    };
    var psp = {
        label: "".concat(formatMessage(messages.psp)),
        key: 'fleet-psp',
        to: isMachineManagementEnabled ? "".concat(types_1.EAuthRoutes.FLEET_OVERVIEW, "/psps") : types_1.FSEAuthRoutes.FLEET_PSP,
        testId: 'sidebar-psp',
    };
    var dtc = {
        label: formatMessage(messages.diagnosticTroubleCodes),
        to: types_1.FSEAuthRoutes.DIAGNOSTIC_TROUBLE_CODES,
        key: 'diagnostic-trouble-codes',
        testId: 'sidebar-diagnostic-trouble-codes',
    };
    var videos = {
        label: formatMessage(messages.videos),
        to: types_1.FSEAuthRoutes.VIDEOS,
        key: 'videos',
        testId: 'sidebar-videos',
        isNew: newFeatureItems === null || newFeatureItems === void 0 ? void 0 : newFeatureItems.videos,
        badgeText: (newFeatureItems === null || newFeatureItems === void 0 ? void 0 : newFeatureItems.videos) ? formatMessage(newFeatureMessages.new) : undefined,
        badgeTooltipText: (newFeatureItems === null || newFeatureItems === void 0 ? void 0 : newFeatureItems.videos) ? formatMessage(newFeatureMessages.newFeatureAvailable) : undefined,
    };
    var CEP_FLEET = isMachineManagementEnabled ? [CEPFleetOverview] : [];
    var FSE_FLEET = !isMachineManagementEnabled ? [FSEFleetOverview] : [];
    var ECOM = isEcomEnabled ? [ECOMSidebarItem] : [];
    var CPQ = isCpqEnabled ? [CPQSidebarItem] : [];
    var SERVICE_AND_INFO_WARRANTY = isWarrantyEnabled ? [warranty] : [];
    var SERVICE_AND_INFO_MANUALS = isManualsEnabled ? [manuals] : [];
    var SERVICE_AND_INFO_PSP = isPSPEnabled ? [psp] : [];
    var SERVICE_AND_INFO_DTC = isDTCEnabled ? [dtc] : [];
    var SERVICE_AND_INFO_VIDEOS = isVideosEnabled ? [videos] : [];
    var items = __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            id: 'account-selector',
            label: activeAccountName,
            icon: 'business',
            trailingIcon: 'agco_chevron-up-down',
            type: 'selector',
            selectorData: {
                activeItemId: activeAccountId,
                onChange: onAccountSelect,
                subItems: accountItems,
            },
            testId: 'sidebar-account-selector',
        },
        {
            label: formatMessage(messages.dashboard),
            icon: 'home',
            to: types_1.EAuthRoutes.DASHBOARD,
            testId: 'sidebar-dashboard',
        }
    ], CEP_FLEET, true), [
        {
            label: formatMessage(messages.serviceAndInformation),
            icon: 'privacy_tip',
            type: 'list',
            id: 'Service & Information',
            testId: 'sidebar-service-and-information',
            listData: {
                basePath: isServiceAndInformationBasePathEnabled ? types_1.FSEAuthRoutes.SERVICE_AND_INFORMATION : '',
                isBasePathLinkOff: !isServiceAndInformationBasePathEnabled,
                items: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], FSE_FLEET, true), SERVICE_AND_INFO_MANUALS, true), SERVICE_AND_INFO_WARRANTY, true), SERVICE_AND_INFO_PSP, true), SERVICE_AND_INFO_DTC, true), SERVICE_AND_INFO_VIDEOS, true),
            },
        }
    ], false), ECOM, true), CPQ, true);
    return items.filter(function (item) { return !!item.to || !!item.onClick || item.type === 'selector' || item.type === 'list'; });
};
exports.useTopItems = useTopItems;
